import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getRentals } from '../../../api/rentals';
import { IUseRental } from '../../../ts/interface/rental.interface';

const useRental = (
  parameters?: IUseRental,
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>
) => {
  const { systemId, queryParameters } = parameters || {};
  return useQuery({
    queryKey: ['rentals', systemId, queryParameters],
    queryFn: () => getRentals(queryParameters, systemId),
    ...options,
  });
};

export default useRental;
